<template>
  <a :class="buttonClass" @click="() => {
    scrollToElement();
    sendYmTarget();
    $emit('click');
  }">
    <svg v-if="nameImage" :class="svgClass" width="25px" height="30px">
      <use :xlink:href="svgHref"></use>
    </svg>
    <p v-if="title" class="function-button__text">{{ title }}</p>
  </a>
</template>
<script>
/* global ym */
export default {
  name: 'ButtonScroll',
  props: {
    title: {
      type: String,
      default: null,
    },
    nameImage: {
      type: String,
      default: null,
    },
    scrollSelector: {
      type: String,
      default: null,
    },
    nameButton: {
      type: String,
      default: null,
    },
    topMarginScroll: {
      type: Number,
      default: 0,
    },
    ymIdTarget: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      svgClass: 'function-button__image',
      svgHref: null,
      buttonClass: 'button function-button',
    };
  },
  created() {
    if (this.svgClass) {
      this.svgClass = `${this.svgClass} ${this.svgClass}_${this.nameImage}`;
    }
    this.svgHref = `#${this.nameImage}`;
    if (this.nameButton) {
      this.buttonClass = `${this.buttonClass} function-button_${this.nameButton}`;
    }
  },
  methods: {
    scrollToElement() {
      const element = document.querySelector(this.scrollSelector);
      const header = window.innerWidth < 580 ? document.querySelector('.mobile-header') : document.querySelector('.header-desktop');

      if (element && header) {
        const heightScroll = element.getBoundingClientRect().top;
        const heightHeader = header.clientHeight;
        window.scrollTo({
          top: heightScroll + window.scrollY - heightHeader - this.topMarginScroll,
          behavior: "smooth",
        })
      }
    },
    sendYmTarget() {
      if (this.ymIdTarget && typeof ym !== 'undefined') {
        ym(57872296, 'reachGoal', this.ymIdTarget);
      }
    },
  },
};
</script>
